import axios, { AxiosRequestConfig } from "axios";
import axiosRetry from "axios-retry";

export type GetFinanceCalculationParams = {
    vehicleId: number;
    preferredDepositAmount: number;
    selectedTerm: number;
    selectedFinanceType: string;
    mileage?: number;
    financeableProductPrices?: number[];
};

export type FinanceCalculationResponse = { Label: string; Value: number; FormattedValue: string }[];
export type FinanceCalculationError = { Message: string };

export const calculateFinance = async (params: GetFinanceCalculationParams) => {
    const axiosConfig: AxiosRequestConfig = {
        params,
        headers: {
            "Content-Type": "application/json",
            Accept: "/",
            "Cache-Control": "no-cache",
        },
        paramsSerializer: {
            indexes: null,
        },
        withCredentials: true,
    };

    axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay });

    const response = await axios.get<FinanceCalculationResponse | FinanceCalculationError>(
        `${process.env.NEXT_PUBLIC_BASE_FINANCE_EXAMPLE_ENDPOINT}/calculate`,
        axiosConfig
    );

    return response;
};
